import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const RegionBasicInfoComponent = ({ employees, rap, zones, onInnerBasicFormChange, selectedRegions }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="MobilityRegionName"
                    name="MobilityRegionName"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MobilityRegionName'

                        )
                    }}
                    type="text"
                    value={selectedRegions?.MobilityRegionName}
                />

                <InputContainer
                    label="Contact Person"
                    name="ContactPerson"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ContactPerson'

                        )
                    }}
                    type="text"
                    value={selectedRegions?.ContactPerson}
                />
                 <InputContainer
                    label="Contact Number"
                    name="ContactNumber"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ContactNumber'

                        )
                    }}
                    type="number"
                    value={selectedRegions?.ContactNumber}
                />
                <InputContainer

                    label="Zone"
                    labelField="MobilityZoneName"
                    list={zones}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MobilityZoneId'

                        );
                    }}
                    optionName='Choose MobilityZone'
                    type="select"
                    value={selectedRegions?.MobilityZoneId}
                    valueField="Id"
                />
                <InputContainer

                    label="Employee"
                    labelField="FirstName"
                    list={employees}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EmployeeId'

                        );
                    }}
                    optionName='Choose Employee'
                    type="select"
                    value={selectedRegions?.EmployeeId}
                    valueField="Id"
                />
                <InputContainer
                    label="Rap"
                    labelField="Name"
                    list={rap}
                    onValueChange={(newValue: any) => {
                        const pinCodeData: any = newValue.map((option: any) => option?.value || '')
                        onInnerBasicFormChange(
                            pinCodeData,
                            'RAPIds'
                        )
                    }}
                    type="multiselect"
                    valueField="Id"
                    value={selectedRegions?.RAPIds}
                />

            </div>
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default RegionBasicInfoComponent;
